module.exports = __webpack_public_path__ + "static/media/envelope.87806a71.svg";